import type {
  ContractTemplate,
  ContractTemplateCreatePayload,
  ContractTemplateListParams,
  ContractTemplateUpdatePayload,
} from "@/types/contractTemplate";

import { api, unwrap } from "./axiosConfig";

const base = (wsId: number) => `/api/v1/workspaces/${wsId}/contract-templates`;

export const contractTemplateService = {
  async list(
    workspaceId: number,
    params?: ContractTemplateListParams,
  ): Promise<ContractTemplate[]> {
    return unwrap(api.get(base(workspaceId), { params }));
  },

  async get(workspaceId: number, id: number): Promise<ContractTemplate> {
    return unwrap(api.get(`${base(workspaceId)}/${id}`));
  },

  async create(
    workspaceId: number,
    payload: ContractTemplateCreatePayload,
  ): Promise<ContractTemplate> {
    return unwrap(api.post(base(workspaceId), payload));
  },

  async update(
    workspaceId: number,
    id: number,
    payload: ContractTemplateUpdatePayload,
  ): Promise<ContractTemplate> {
    return unwrap(api.patch(`${base(workspaceId)}/${id}`, payload));
  },

  async remove(workspaceId: number, id: number): Promise<void> {
    await api.delete(`${base(workspaceId)}/${id}`);
  },
};
